import type { Sprite } from '../../gfx/atlas';
import type { Renderer } from '../../gfx/renderer';
import { Screen } from '../../engine/screen';
import { drawLogo, type Kit, loadKit } from '../kit';
import { MainMenuScreen } from './main-menu';

/** The LoD splash: trademark art + burning logo. Any click or key continues. */
export class TrademarkScreen extends Screen {
  private bg!: Sprite;
  private kit!: Kit;
  private t = 0;

  override async load(): Promise<void> {
    this.kit = await loadKit(this.app.assets, this.app.audio);
    this.bg = await this.app.assets.image('data\\global\\ui\\FrontEnd\\trademarkscreenEXP.dc6');
  }
  override enter(): void {
    void this.app.audio.playMusic('data\\global\\music\\introedit.wav');
  }
  override update(dt: number): void {
    this.t += dt;
  }
  render(r: Renderer): void {
    r.draw(this.bg, 0, 0, { topLeft: true, palette: this.app.assets.palette.Sky });
    drawLogo(r, this.kit, 400, 120, this.t);
    const f = this.kit.fonts.formal10;
    f.draw(r, 'An unofficial fan-made engine. Diablo II is a trademark of Blizzard Entertainment.', 400, 560, { align: 'center', color: 7 });
  }
  private next(): void {
    if (this.t > 0.3) void this.app.go(new MainMenuScreen());
  }
  override onMouseDown(): void {
    this.next();
  }
  override onKeyDown(): boolean {
    this.next();
    return true;
  }
}
